/** @jsxImportSource theme-ui */
import { Button, Text, Textarea, Label, Input, Flex } from 'theme-ui';
import React from "react";

const Step5 = (props) => {
const { data, handleChange, home, sendChatMessage, loadMessages } = props;
  return (
    <div
    sx={{
      display: 'flex',
      flexDirection: 'column',  
      // set this to `minHeight: '100vh'` for full viewport height
      // minHeight: 256,
      minHeight: '100vh',
    }}>
    <div   // centered container
    sx={{ 
      maxWidth: 768,
      mx: 'auto',
      px: 3,
      }}>  
      <header
        sx={{
          width: '100%',          
        }}>
        <p><b>Encrypted Messaging for Lens 🌿, powered by XMTP Labs </b></p>
      </header>

      <main
        sx={{
          width: '100%',
          flex: '1 1 auto',
        }}>

        <Text><b style={{color: 'red'}}>Note: </b></Text>
        <Text><i style={{color: 'red'}}> MetaMask signing pop-up MUST be triggered manually.</i></Text><br />
        <Text><i style={{color: 'red'}}> Look for the alerts on the MM fox icon in the Extensions bar.</i></Text>

        <br /> <br /> 
        <Label>Enter the Lens Profile Handle: </Label>
        <Flex mb={2}>  
          <Input sx={{width:"260px", height:"40px"}}
            type="text"
            name="lensHandle"
            value={data.lensHandle}   
            placeholder='stani.lens'
            onChange={handleChange}
          />
          <Button sx={{width:"150px", height:"40px", marginLeft:"auto"}}  variant='primary' id="decMsgBtnXXX" onClick={sendChatMessage}>Send Message</Button>  
        </Flex>

        <Textarea
          name="chatMessageText"
          id='chat_message_box' 
          rows="3"
          placeholder='Enter message here...'
          onChange={handleChange}
        ></Textarea>
        <div id="sendingChatStatus"></div>

        <br /> <br /> 

        <Flex mb={2}>  
          <Button sx={{width:"150px", height:"40px", marginLeft:"auto" }}  variant='primary' id="decMsgBtnXXX" onClick={loadMessages}>Load Messages</Button>  
        </Flex>


        <Textarea
          name="myMessages"
          id='my_messages' 
          rows="10"
          placeholder='- Press Load Messages to get chats from last 48 hours.  - XMTP notifications are not supported here.            - Just keep pressing Load Messages!'
          onChange={handleChange}
        ></Textarea>
        <div id="sendingChatStatus"></div>
        
        <br /> <br /> 
        <Button variant='secondary' onClick={home} >Home</Button>
        <br /> <br /> 
      </main>

      <footer
        sx={{
          width: '100%',
        }}>
          <div sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between'  }}>  
            <Text><a href="https://lenster.xyz/u/lensprotocol" style={{color: 'blue'}} >🌿 Lens Protocol</a></Text>            
            <Text><a href="https://xmtp.com/" style={{color: 'blue'}} >XMTP</a></Text>
          </div>
      </footer>
    </div>
    </div>
  );
};

export default Step5;